import { render, staticRenderFns } from "./xlzd.vue?vue&type=template&id=3465793e&scoped=true"
import script from "./xlzd.vue?vue&type=script&lang=js"
export * from "./xlzd.vue?vue&type=script&lang=js"
import style0 from "./xlzd.vue?vue&type=style&index=0&id=3465793e&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3465793e",
  null
  
)

export default component.exports